<script setup>
import { mapState } from "vuex";
</script>
<template>
    <b-nav class="nav-toggled">
        <b-nav-item-dropdown no-caret :text="$t('indicator')" class="toggled" id="indicator" left>
            <b-dropdown-item to="/indicatorsEditor/edition" class="drop-item">
                <img class="dropItem" src="@/assets/editInd.png" alt="Editar Indicadores" />
                {{ $t('edition') }}
            </b-dropdown-item>

            <b-dropdown-item class="drop-item" to="/indicatorsEditor/creation">
                <img class="dropItem" src="@/assets/add.png" alt="Criar Indicadores" />
                {{ $t('creation') }}
            </b-dropdown-item>
        </b-nav-item-dropdown>
    </b-nav>
</template>
<script>
export default {
    name: 'IndicatorEditorDropdown',
    computed: mapState(["user"]),
}

</script>
<style scoped>
img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.dropdown-menu {
  height: auto;
  max-height: 350px;
  overflow-y: auto;
}

.ilink {
  margin-right: 10px;
}

.txt {
  color: white;
  padding: 10px 20px;
}
</style>